import { motion } from 'framer-motion';
import styled, { keyframes } from 'styled-components';

const ShadematchLoadingOverlay = () => (
	<LoadingContainer initial={{ opacity: 1 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.45 }}>
		<ShadeDots role='status' aria-label='Shade match in progress'>
			{shadeColors.map((color, index) => (
				<ShadeDot key={color} $color={color} $delay={index * 0.3} />
			))}
		</ShadeDots>
	</LoadingContainer>
);

const shadeColors = ['#f1d6c2', '#d5aa89', '#a77455', '#68412f'];

const shadeScroll = keyframes`
	0%, 12% {
		background-color: #d9d9d9;
		transform: translateY(0);
	}

	24%, 62% {
		background-color: var(--shade-color);
		transform: translateY(-6px);
	}

	74%, 100% {
		background-color: #d9d9d9;
		transform: translateY(0);
	}
`;

const LoadingContainer = styled(motion.main)`
	position: fixed;
	inset: 0;
	z-index: 4;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff;
`;

const ShadeDots = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
`;

const ShadeDot = styled.span<{ $color: string; $delay: number }>`
	--shade-color: ${(props) => props.$color};
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background-color: #d9d9d9;
	animation: ${shadeScroll} 2.4s ease-in-out ${(props) => props.$delay}s infinite;
`;

export default ShadematchLoadingOverlay;
